import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountPasswordReset" })
export default class AccountPasswordReset extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];

    @Prop() readonly code: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.options = (await Axios.post(this.routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        this.formData.code = this.code;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.Account_PasswordReset, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl;
        } catch (error) {
            this.formData.password = null;
            this.formData.passwordCheck = null;

            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};